(function () {
  'use strict';

  /* Guard against this file being loaded twice. Without it, a second load
     installs a second fetch wrapper on top of the first, so every cart
     request triggers two refreshes. */
  if (window.__cartDrawerCustomLoaded) return;
  window.__cartDrawerCustomLoaded = true;

  var CART_EMPTY_SVG = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-cart-empty" viewBox="0 0 40 40"><path fill="currentColor" fill-rule="evenodd" d="M15.75 11.8h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33L28.4 11.8zm0 1h-2.22l-.71 10.67a4 4 0 0 0 3.99 4.27h7.38a4 4 0 0 0 4-4.27l-.72-10.67h-2.22v.63a4.75 4.75 0 1 1-9.5 0zm8.5 0h-7.5v.63a3.75 3.75 0 1 0 7.5 0z"></path></svg>';
  var CART_FULL_SVG = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-cart" viewBox="0 0 40 40"><path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 0 0-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0 0 20.5 6.5m3.75 5.31v-.56a3.75 3.75 0 1 0-7.5 0v.56zm-7.5 1h7.5v.56a3.75 3.75 0 1 1-7.5 0zm-1 0v.56a4.75 4.75 0 1 0 9.5 0v-.56h2.22l.71 10.67a4 4 0 0 1-3.99 4.27h-7.38a4 4 0 0 1-4-4.27l.72-10.67z"></path></svg>';

  /* Bound so `this` is always window, whoever calls it. */
  var originalFetch = window.fetch.bind(window);

  var _iconObserver = null;
  var _observerTimer = null;
  var _qtyObservers = [];
  var _bubbleTimers = [];
  var _bubbleDebounce = null;
  var _refreshToken = 0;
  var _lastCount = -1;

  var JSON_HEADERS = { Accept: 'application/json' };

  /* ── Timer bookkeeping ──
     updateCartBubble schedules work 250ms and 280ms out. If a second cart
     change lands inside that window the two runs interleave and leave a
     stale bubble, so every pending timer is tracked and cancelled. */
  function later(fn, ms) {
    var id = setTimeout(fn, ms);
    _bubbleTimers.push(id);
    return id;
  }

  function clearBubbleTimers() {
    _bubbleTimers.forEach(clearTimeout);
    _bubbleTimers = [];
  }

  /* ── Banner ── */
  function initBanner() {
    var msgs = document.querySelectorAll('.cd-banner-msg');
    if (msgs.length < 2) return;
    var idx = 0;
    if (window._cdBannerInterval) clearInterval(window._cdBannerInterval);
    window._cdBannerInterval = setInterval(function () {
      msgs[idx].classList.remove('cd-banner-active');
      idx = (idx + 1) % msgs.length;
      msgs[idx].classList.add('cd-banner-active');
    }, 3000);
  }

  /* ── Price Summary ── */
  window.cdToggleSummary = function () {
    var s = document.getElementById('cd-price-summary');
    var c = document.querySelector('.cd-chevron');
    if (!s) return;
    var show = s.style.display === 'none' || !s.style.display;
    s.style.display = show ? 'block' : 'none';
    if (c) c.classList.toggle('cd-chevron-up', show);
  };

  /* ── Reco helpers ── */
  function revealNextHidden(carousel) {
    if (!carousel) return;
    var h = carousel.querySelector('.cd-reco-hidden');
    if (!h) return;
    h.classList.remove('cd-reco-hidden');
    h.style.opacity = '0';
    h.style.transform = 'translateX(20px)';
    requestAnimationFrame(function () {
      h.style.transition = 'opacity .3s,transform .3s';
      h.style.opacity = '1';
      h.style.transform = 'translateX(0)';
    });
  }

  /* ── Reco Add (delegated) ──
     Asks /cart/add.js for the rendered cart-drawer section in the same
     request, so this is two round trips instead of three. Uses originalFetch
     so it does not also trip the interceptor below and double-refresh. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cd-reco-add');
    if (!btn || btn.classList.contains('cd-adding')) return;

    var vid = btn.dataset.variantId;
    if (!vid) return;

    var originalLabel = btn.textContent;
    btn.classList.add('cd-adding');
    btn.disabled = true;
    btn.textContent = '...';

    var card = btn.closest('.cd-reco-card');
    var carousel = btn.closest('.cd-reco-carousel');

    function restore() {
      btn.classList.remove('cd-adding');
      btn.disabled = false;
      btn.textContent = originalLabel || 'Add';
    }

    originalFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(vid), quantity: 1 }],
        sections: 'cart-drawer',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add failed: ' + r.status);
        return r.json();
      })
      .then(function (state) {
        var sectionHTML = state && state.sections && state.sections['cart-drawer'];
        if (sectionHTML) applyDrawerHTML(sectionHTML);

        if (card) {
          card.style.transition = 'opacity .3s,transform .3s';
          card.style.opacity = '0';
          card.style.transform = 'scale(.8)';
          setTimeout(function () {
            card.remove();
            revealNextHidden(carousel);
          }, 300);
        }

        /* /cart/add.js returns the added line, not the whole cart, so the
           count still needs its own read. */
        return originalFetch('/cart.js', { headers: JSON_HEADERS })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            fireCartUpdated(cart);
            if (!sectionHTML) {
              refreshDrawer(function () { updateCartBubble(cart); });
            } else {
              updateCartBubble(cart);
            }
          });
      })
      .catch(function (err) {
        console.error('[cart-drawer-custom]', err);
        restore();
      });
  });

  /* ── Qty minus disable ──
     Rebinds only on nodes that have not been bound, and disconnects the
     previous batch of observers. The original created a fresh observer per
     input on every drawer refresh and never disconnected any of them. */
  function initMinusDisable() {
    _qtyObservers.forEach(function (o) { o.disconnect(); });
    _qtyObservers = [];

    document.querySelectorAll('cart-drawer .cd-qty-input').forEach(function (qi) {
      var input = qi.querySelector('.quantity__input');
      var minus = qi.querySelector('button[name="minus"]');
      if (!input || !minus) return;

      function check() {
        var v = parseInt(input.value, 10) || 1;
        var m = parseInt(input.getAttribute('min'), 10) || 1;
        minus.toggleAttribute('disabled', v <= m);
      }

      check();

      if (!qi.dataset.cdMinusBound) {
        qi.dataset.cdMinusBound = '1';
        input.addEventListener('change', check);
        input.addEventListener('input', check);
      }

      var mo = new MutationObserver(check);
      mo.observe(input, { attributes: true, attributeFilter: ['value'] });
      _qtyObservers.push(mo);
    });
  }

  /* ── Drawer refresh ── */
  function swap(sel, doc) {
    var n = doc.querySelector(sel);
    var o = document.querySelector(sel);
    if (n && o) o.innerHTML = n.innerHTML;
  }

  function applyDrawerHTML(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    swap('cart-drawer-items', doc);
    swap('.drawer__footer', doc);
    swap('.cd-cart-details-header', doc);

    var cd = document.querySelector('cart-drawer');
    var nd = doc.querySelector('cart-drawer');
    if (cd && nd) cd.classList.toggle('is-empty', nd.classList.contains('is-empty'));

    initMinusDisable();
    initBanner();
  }

  function refreshDrawer(cb) {
    originalFetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        applyDrawerHTML(html);
        if (cb) cb();
      })
      .catch(function (err) {
        console.error('[cart-drawer-custom] drawer refresh failed', err);
        if (cb) cb();
      });
  }

  /* ══════════════════════════════════════
     Cart bubble + SVG swap + animation
     ══════════════════════════════════════ */

  /* What the DOM currently shows, so a bubble Dawn wiped out is detected
     even when the count itself has not changed. */
  function domBubbleCount() {
    var b = document.getElementById('cd-cart-count-bubble');
    if (!b) return 0;
    var n = parseInt(b.textContent, 10);
    return isNaN(n) ? 0 : n;
  }

  function ensureObserver(delay) {
    if (_observerTimer) clearTimeout(_observerTimer);
    _observerTimer = setTimeout(startIconObserver, delay || 300);
  }

  function updateCartBubble(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;

    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;

    var count = cart.item_count;

    /* Skip only when the count is unchanged AND the bubble on screen still
       agrees with it. The original reset _lastCount to -1 inside the
       observer, which meant this guard never fired and every unrelated Dawn
       re-render triggered a full animation cycle. */
    if (count === _lastCount && domBubbleCount() === count) {
      ensureObserver();
      return;
    }

    clearBubbleTimers();
    if (_observerTimer) {
      clearTimeout(_observerTimer);
      _observerTimer = null;
    }
    if (_iconObserver) _iconObserver.disconnect();

    _lastCount = count;

    var old = document.getElementById('cd-cart-count-bubble');
    if (old) old.remove();
    icon.querySelectorAll('.cart-count-bubble').forEach(function (b) { b.remove(); });

    var wrap = icon.querySelector('.svg-wrapper');
    if (wrap) {
      wrap.style.transition = 'opacity .25s ease';
      wrap.style.opacity = '0';
      later(function () {
        /* Re-query: the icon section may have been replaced during the fade. */
        var i = document.getElementById('cart-icon-bubble');
        var w = i && i.querySelector('.svg-wrapper');
        if (!w) return;
        w.innerHTML = count > 0 ? CART_FULL_SVG : CART_EMPTY_SVG;
        w.style.opacity = '1';
      }, 250);
    }

    if (count > 0) {
      later(function () {
        var i = document.getElementById('cart-icon-bubble');
        if (!i) return;
        if (document.getElementById('cd-cart-count-bubble')) return;
        if (getComputedStyle(i).position === 'static') i.style.position = 'relative';

        var b = document.createElement('span');
        b.id = 'cd-cart-count-bubble';
        b.setAttribute('aria-hidden', 'true');
        b.textContent = count;
        b.style.cssText = 'position:absolute;top:0;right:-4px;background:#235a49;color:#fff;font-size:10px;font-weight:700;min-width:18px;height:18px;line-height:18px;text-align:center;border-radius:50%;padding:0 4px;pointer-events:none;z-index:9999;transform:scale(0);transition:transform .3s cubic-bezier(.34,1.56,.64,1);';

        var vh = i.querySelector('.visually-hidden');
        if (vh) i.insertBefore(b, vh); else i.appendChild(b);

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            b.style.transform = 'scale(1)';
          });
        });
      }, 280);
    }

    ensureObserver(800);
  }

  /* Coalesces bursts of cart mutations into one read, and drops responses
     that arrive out of order. */
  function scheduleBubbleRefresh(delay) {
    if (_bubbleDebounce) clearTimeout(_bubbleDebounce);
    _bubbleDebounce = setTimeout(function () {
      _bubbleDebounce = null;
      var token = ++_refreshToken;
      originalFetch('/cart.js', { headers: JSON_HEADERS })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (token !== _refreshToken) return;
          updateCartBubble(cart);
        })
        .catch(function () {
          ensureObserver();
        });
    }, delay == null ? 400 : delay);
  }

  /* ── Watch for Dawn overwriting the icon ── */
  function startIconObserver() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    if (_iconObserver) _iconObserver.disconnect();

    _iconObserver = new MutationObserver(function () {
      _iconObserver.disconnect();
      scheduleBubbleRefresh(200);
    });
    _iconObserver.observe(icon, { childList: true, subtree: true });
  }

  /* ── Intercept fetch for cart changes ──
     Returns the response object untouched so downstream callers can still
     read the body. Only reacts to successful mutations. */
  window.fetch = function () {
    var args = arguments;
    var first = args[0];
    var url = typeof first === 'string' ? first : (first && first.url ? first.url : '');

    return originalFetch.apply(null, args).then(function (res) {
      if (res && res.ok && /\/cart\/(add|change|update|clear)/.test(url)) {
        scheduleBubbleRefresh(500);
      }
      return res;
    });
  };

  function fireCartUpdated(cart) {
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (e) {}
  }

  /* ── Init ── */
  function init() {
    initBanner();
    initMinusDisable();
    scheduleBubbleRefresh(500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var drawerEl = document.querySelector('.drawer');
  if (drawerEl) {
    new MutationObserver(function () {
      setTimeout(function () {
        initBanner();
        initMinusDisable();
      }, 100);
    }).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
  }
})();